import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Logo from '../../Navbar/Logo/Logo';
import AdminSidebar from '../AdminSidebar/AdminSidebar';

const UpdateProduct = () => {

    const [imageURL, setImageURL] = useState(null);
    const [imageURLStatus, setImageURLStatus] = useState();
    const [dbStatus, setDbStatus] = useState(false);
    const [product, setProduct] = useState([]);

    const { id } = useParams();


    useEffect(() => {
        fetch(`https://mamar-dukan.herokuapp.com/products/${id}`)
            .then(res => res.json())
            .then(data => setProduct(data.product))
    }, [id])


    const handleSubmit = e => {

        const productInfo = {
            name: e.target.name.value || product.name,
            description: e.target.description.value || product.description,
            size: e.target.size.value || product.size,
            category: e.target.category.value || product.category,
            color: e.target.color.value || product.color,
            department: e.target.department.value || product.department,
            price: e.target.price.value || product.price,
            brand: e.target.brand.value || product.brand,
            img: imageURL || product.img
        };


        const url = `https://mamar-dukan.herokuapp.com/products/${id}`;
        fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productInfo)
        })
            .then(res => res.json())
            .then(data => {
                if (data) {
                    setDbStatus(data);
                    alert('Product Updated');
                }
            })
        e.preventDefault();
    }


    const handleImageUpload = (event) => {
        const imageData = new FormData()
        imageData.set('key', 'ca6c9c7b95b538d35b5137a6b8deb060');
        imageData.append('image', event.target.files[0])

        axios.post('https://api.imgbb.com/1/upload', imageData)
            .then(function (response) {
                setImageURL(response.data.data.display_url);
                setImageURLStatus(true);
                if (response) {
                    alert('Image Uploaded Successfully')
                }
            })
            .catch(function (error) {
            });
    }



    return (
        <>
            <div className=" bg-gray-800 ">
                <div className="w-screen h-20 p-6">
                    <Logo />
                </div>

                <div className="flex  md:flex-row flex-col">
                    <AdminSidebar />

                    <section className="mx-10">
                        <h1 className="font-bold text-white p-4 text-2xl">Update Product</h1>
                        <div class="  ">

                            <form
                                class=" shadow-md rounded bg-blue-100 p-6 pb-8 mb-4 grid grid-cols-3 gap-4"
                                onSubmit={handleSubmit}
                            >
                                <div class="mb-4">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="name"
                                    >
                                        Name
                                    </label>
                                    <input
                                        class="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="text"
                                        name="name"
                                        defaultValue={product.name}
                                    />
                                </div>

                                <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="category"
                                    >
                                        Category: <span className="text-blue-600">{product.category}</span>
                                    </label>
                                    <select className="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600" name="category" id="cars">

                                        <option value="None">None</option>
                                        <option value="Man">Man</option>
                                        <option value="Women">Women</option>
                                    </select>
                                    {/* <input
                                        class="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="text"
                                        name="category"
                                        placeholder="Category"
                                    /> */}
                                </div>

                                <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="department"
                                    >
                                        Department: <span className="text-blue-600">{product.department}</span>
                                    </label>
                                    <select className="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600" name="department" id="cars">
                                        <option value="Clothing">Clothing</option>
                                        <option value="Grocery">Grocery</option>
                                        <option value="Cooking">Cooking</option>
                                        <option value="Phone">Phone</option>
                                        <option value="Cosmetics">Cosmetics</option>
                                        <option value="Computer">Computer</option>
                                    </select>
                                    {/* <input
                                        class="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="text"
                                        name="department"
                                        placeholder="department"
                                    /> */}
                                </div>

                                <div class="mb-4">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="brand"
                                    >
                                        Brand
                                    </label>
                                    <input
                                        class="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="text"
                                        list="brand"
                                        name="brand"
                                        defaultValue={product.brand}
                                    />
                                    <datalist id="brand">
                                        <option value="Easy" />
                                        <option value="Nike" />
                                        <option value="Adidas" />
                                        <option value="Zodiac" />
                                        <option value="Levi's" />
                                    </datalist>
                                </div>

                                <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="size"
                                    >
                                        Size: <span className="text-blue-600">{product.size}</span>
                                    </label>
                                    <select className="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600" name="size" id="cars">
                                        <option value="none">None</option>
                                        <option value="S">S</option>
                                        <option value="M">M</option>
                                        <option value="L">L</option>
                                        <option value="XL">XL</option>
                                        <option value="XXL">XXL</option>
                                        <option value="XXL">XXXL</option>
                                    </select>
                                    {/* <input
                                        className="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="text"
                                        name="size"
                                        placeholder="Size"
                                    /> */}
                                </div>

                                <div class="mb-6 md:mx-32">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="color"
                                    >
                                        Color
                                    </label>
                                    <input
                                        class="px-2 shadow appearance-none border-0 rounded w-full text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="color"
                                        name="color"
                                        // defaultValue={product.color}
                                        defaultValue={product.color}
                                        // value={product.color}
                                    />
                                </div>

                                <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="price"
                                    >
                                        price
                                    </label>
                                    <input
                                        class="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="number"
                                        min="1"
                                        name="price"
                                        defaultValue={product.price}
                                    />
                                </div>{" "}

                                {/* <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="seller"
                                    >
                                        seller
                                    </label>
                                    <input
                                        class="shadow appearance-none border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="text"
                                        name="seller"
                                        placeholder="seller"
                                    />
                                </div> */}

                                <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="image"
                                    >
                                        Image
                                    </label>
                                    <input
                                        class="shadow appearance-none border-1 hover:bg-blue-600 hover:text-gray-50 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        onChange={handleImageUpload}
                                        type="file"
                                        name="image"
                                    />
                                    {imageURLStatus ?
                                        <small className="text-green-600">Image Uploaded</small>
                                        :
                                        <small className="text-red-700">Upload Image</small>
                                    }
                                    <img className="w-12 mx-36" src={product.img} alt="" />

                                </div>{" "}

                                <div class="mb-6">
                                    <label
                                        class="block text-gray-700 text-sm font-bold mb-2"
                                        for="description"
                                    >
                                        Description
                                    </label>
                                    <input
                                        class="shadow appearance-none h-24 border-0 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-600"
                                        type="textarea"
                                        name="description"
                                        defaultValue={product.description}
                                    />
                                </div>
                                <div class="flex items-end justify-end">
                                    <button
                                        class="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default UpdateProduct;
